import React from "react";
import { ThemeProvider } from "styled-components";
import { IntercomProvider } from "react-use-intercom";
import { AuthProvider, ImpersonationOverlay } from "../../lib/auth";
import { withFeatureFlagProvider } from "../../lib/feature-flags";
import Routes, { privateRoutes } from "./Routes";
import theme from "../theme";
import Layout from "./Layout";
import Header from "../Header";
import Footer from "../Footer";
import RecommendedJobsProvider from "../job-search/RecommendedJobsProvider";
import PGALogo from "../../assets/images/logo.svg";
import IntercomWithAuth from "../Intercom";
import RaygunUser from "../Raygun";
import PromptModal from "./modal/PromptModal";

export const GetHeader = () => (
  <Header {...{ logo: PGALogo, bgColor: theme.colors.secondary }} />
);
export const GetFooter = () => <Footer />;

const App = () => (
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <IntercomProvider
        appId={process.env.REACT_APP_INTERCOM_APP_ID}
        autoBoot={false}
      >
        <RecommendedJobsProvider>
          <ImpersonationOverlay />
          <Layout Header={GetHeader} Footer={GetFooter}>
            <PromptModal privateRoutes={privateRoutes} />
            <Routes />
          </Layout>
          <RaygunUser />
        </RecommendedJobsProvider>
        <IntercomWithAuth />
      </IntercomProvider>
    </AuthProvider>
  </ThemeProvider>
);

export default withFeatureFlagProvider(App);
